import React from 'react';

function RenderMedia({ type, url }) {
  switch (type) {
    case 'Image':
      return <img src={url} alt="Dynamic Content" className="w-full h-full object-cover" />;
    case 'Video':
      return (
        <video controls className="w-full h-full object-cover">
          <source src={url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    default:
      return <p>Unsupported file type</p>;
  }
}

export default RenderMedia;
